// Section 3 observer mode and 24.10: the steward plays the default policies; the player watches
// with Play, Pause and Step. Prompts are answered with the steward's default answers.
import { steward, stewardAnswer } from '../../sim/api';
import { withBoundary } from '../boundary';
import { runConfig } from '../run';
import { draft, game, status, ui } from '../state';
import { answerPrompt, dismissReport, endSeason } from './game';
import { startObserverTimer, stopObserver } from './observer-timer';

/** Advance one step of the turn flow the way the steward would. Returns false when done. */
export const observerStep = withBoundary((): boolean => {
  const g = game.value;
  if (g === null) return false;
  switch (status.value) {
    case 'reporting':
      dismissReport();
      return true;
    case 'deciding':
      draft.value = steward(g, runConfig());
      endSeason();
      return true;
    case 'paused': {
      const prompt = g.pendingPrompts[0];
      if (prompt === undefined) return false;
      answerPrompt(prompt.id, stewardAnswer(g, prompt, runConfig()));
      return true;
    }
    case 'title':
    case 'resolving':
    case 'ended':
      return false;
  }
});

export const OBSERVER_INTERVAL_MS = 700;

export function observerPlay(intervalMs = OBSERVER_INTERVAL_MS): void {
  startObserverTimer(() => {
    const advanced = observerStep();
    if (advanced !== true || ui.value.error !== null) stopObserver();
  }, intervalMs);
}

export const observerPause = stopObserver;
